import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: 'us-west-2_sdZ8YhpTI',
      userPoolClientId: '31irjr7gtkpu8bktebf2pbrnci',
      region: 'us-west-2',
      signUpVerificationMethod: 'code',
      loginWith: {
        email: true,
      }
    }
  }
});